// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"af3c00ed","787":"f5242312"}[chunkId] + ".chunk.js";
};